export default "__VITE_ASSET__DtzZh3VL__"